export const firebaseConfig = {
  apiKey: 'AIzaSyCo6Oo3UbGNkyBcan8h85B7CrEs6hL87oI',
  authDomain: 'qrinformer.firebaseapp.com',
  projectId: 'qrinformer',
  storageBucket: 'qrinformer.firebasestorage.app',
  messagingSenderId: '233927066754',
  appId: '1:233927066754:web:e3f569eb1bd9cd1251e09b',
  measurementId: 'G-QZ5793HEVZ',
};
